import * as _ from 'lodash-es';
import { AdminOcupation } from '../model/adminOcupation';
import { AdminOcupationDaysBuilder } from './adminOcupationDays-builder';
export class AdminOcupationBuilder {
    static buildAdminOcupation(data) {
        const adminOcupation = new AdminOcupation();
        adminOcupation.step_end = data.step_end;
        adminOcupation.step_start = data.step_start;
        adminOcupation.days = _.map(data.days, (adminOcupationDays) => {
            return AdminOcupationDaysBuilder.buildAdminOcupationDays(adminOcupationDays);
        });
        adminOcupation.average = _.sumBy(data.days, 'reservations') / data.days.length;
        return adminOcupation;
    }
}
//# sourceMappingURL=adminOcupation-builder.js.map